export const isChrome = (ua) => ua?.includes('Chrome') ?? false;
export const isFirefox = (ua) => ua?.includes('Firefox') ?? false;
export const isMobileSafari = (ua) => ua?.includes('Mobile Safari') ?? false;
export const isSamsungBrowser = (ua) => ua?.includes('SamsungBrowser') ?? false;
export const isMetaBrowser = (ua) => ua?.includes('FBAN') || ua?.includes('FBAV') || ua?.includes('Instagram') || false;
export const isWindowsApp = (ua) => ua?.includes('WindowsApp') ?? false;
//# sourceMappingURL=browser.js.map